<template>
  <div>
    <el-row :gutter="10" style="margin: 10px 15px">
      <el-col :xs="24" :lg="8" style="padding: 6px 0px">
        <span> 时间类型： </span>
        <el-radio-group v-model="dataTpye" @change="getShowData" size="mini">
          <el-radio label="currMonth" v-if="dataRange === 'month'"
            >当月</el-radio
          >
          <el-radio label="currQuarter" v-if="dataRange === 'quarter'"
            >当季</el-radio
          >
          <el-radio label="all">本年累计</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :xs="24" :lg="8" style="padding: 6px 0">
        <span> 数据指标： </span>
        <el-select
          v-model="dataIndex"
          placeholder="请选择"
          @change="changeDataIndex"
          size="mini"
        >
          <el-option
            v-for="item in dataIndexOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="8" style="padding: 6px 0">
        <span> 数据类型： </span>
        <el-select
          v-model="dataRange"
          @change="dataRangeChange"
          placeholder="请选择"
          size="mini"
        >
          <el-option
            v-for="item in dataRangeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        :xs="24"
        :lg="8"
        style="padding: 0px 0"
        v-if="dataRange === 'month'"
      >
        <span style="margin-left: 40px"> 时间： </span>
        <el-date-picker
          class="jiance_phone_date"
          :editable="false"
          :clearable="false"
          v-model="times"
          type="monthrange"
          value-format="yyyy-MM"
          size="mini"
          @change="monthChange"
          :picker-options="pickerOptions"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-col>
      <el-col
        :xs="24"
        :lg="8"
        style="padding: 6px 0"
        v-if="dataRange === 'quarter'"
      >
        <span>
          <quarterRange
            style="margin-left: 44px"
            :default-value="defaultQuarterValue"
            v-on:getQuarter="getQuarter"
          ></quarterRange>
        </span>
      </el-col>
      <el-col
        :xs="24"
        :lg="8"
        style="padding: 6px 0"
        v-if="dataRange === 'year'"
      >
        <span>
          <year-range
            style="margin-left: 44px"
            :start-time-def="startTimeDef"
            :end-time-def="endTimeDef"
            v-on:getYearRange="getYearRange"
          ></year-range>
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin: 10px 15px">
      <el-col align="center" style="font-size: 16px">
        全县{{
          dataIndexOptions.find((ele) => ele.value === dataIndex).label
        }}情况
      </el-col>
    </el-row>
    <el-row style="margin: 10px 15px">
      <el-col :span="24">
        <Area v-if="showArea" :area-data="areaData" />
      </el-col>
    </el-row>
    <el-link style="margin: 10px 15px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-row style="margin: 10px 15px">
      <el-col :span="24">
        <el-table
          v-if="dataRange === 'month'"
          v-loading="loading"
          size="mini"
          border
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
          :row-class-name="tableRowClassName"
          :data="tableData"
        >
          <el-table-column type="index" label="序号" width="50" fixed>
          </el-table-column>
          <el-table-column prop="date_range_show" label="时间" fixed>
          </el-table-column>
          <el-table-column label="当月数据">
            <el-table-column
              prop="curr"
              sortable
              :formatter="handelFix2"
              label="当期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="pre"
              sortable
              :formatter="handelFix2"
              label="上年同期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="growthRate"
              sortable
              :formatter="handelFix1"
              label="同比增长(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="本年累计">
            <el-table-column
              prop="currCount"
              sortable
              :formatter="handelFix2"
              label="当期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="preCount"
              sortable
              :formatter="handelFix2"
              label="上年同期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="growthRateCount"
              sortable
              :formatter="handelFix1"
              label="同比增长(%)"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-table
          v-if="dataRange === 'quarter'"
          v-loading="loading"
          size="mini"
          border
          :header-cell-style="{ background: '#5aa1e2', color: '#ffffff' }"
          :row-class-name="tableRowClassName"
          :data="tableData"
        >
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="date_range_show" label="时间" width="150">
          </el-table-column>
          <el-table-column label="当季数据">
            <el-table-column
              prop="curr"
              sortable
              :formatter="handelFix2"
              label="当期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="pre"
              sortable
              :formatter="handelFix2"
              label="上年同期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="growthRate"
              sortable
              :formatter="handelFix1"
              label="同比增长(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="本年累计">
            <el-table-column
              prop="currCount"
              sortable
              :formatter="handelFix2"
              label="当期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="preCount"
              sortable
              :formatter="handelFix2"
              label="上年同期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="growthRateCount"
              sortable
              :formatter="handelFix1"
              label="同比增长(%)"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-table
          v-if="dataRange === 'year'"
          v-loading="loading"
          size="mini"
          border
          :header-cell-style="{ background: '#5aa1e2', color: '#ffffff' }"
          :row-class-name="tableRowClassName"
          :data="tableData"
        >
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="date_range_show" label="时间">
          </el-table-column>
          <el-table-column label="本年累计">
            <el-table-column
              prop="currCount"
              sortable
              :formatter="handelFix2"
              label="当期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="preCount"
              sortable
              :formatter="handelFix2"
              label="上年同期（亿元）"
            >
            </el-table-column>
            <el-table-column
              prop="growthRateCount"
              sortable
              :formatter="handelFix1"
              label="同比增长(%)"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Area from "@/components/Echarts/area.vue";
import quarterRange from "../../../components/dateUtils/quarterRange";
import YearRange from "../../../components/dateUtils/yearRange";
import { export2Excel } from "@/utils/utils";
export default {
  props: {
    dataTpyeDef: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    regionCodeDef: {
      type: String,
      default: "",
    },
    dataIndexDef: {
      type: String,
      default: "",
    },
    dataRangeDef: {
      type: String,
      default: "",
    },
    timesDef: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      exportLabel: "<<点击此处可导出报表",
      showArea: false,
      loading: false,
      areaName: "",
      startTime: "",
      endTime: "",
      startTimeDef: "",
      QuarterValue: [],
      endTimeDef: "",
      srcDataList: "",
      dialogTableVisible: false,
      queryData: {
        code: this.regionCodeDef,
      },
      dataIndexOptions: [
        {
          value: "gytz",
          label: "工业投资",
        },
        {
          value: "jgtz",
          label: "技改投资",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: this.dataTpyeDef, //时间类型
      dataIndex: this.dataIndexDef, //数据指标
      dataRange: this.dataRangeDef, //数据类型
      times: this.timesDef, //时间
      defaultQuarterValue: [], //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      },
    };
  },
  components: {
    YearRange,
    Area,
    quarterRange,
  },
  watch: {
    dataRange: function (value, oldValue) {
      if (value === "quarter") {
        this.times = this.defaultQuarterValue;
        const startArr = ["-01", "-04", "-07", "-10"];
        const endArr = ["-03", "-06", "-09", "-12"];
        this.startTime =
          this.defaultQuarterValue[0].slice(0, 4) +
          startArr[parseInt(this.defaultQuarterValue[0].slice(5, 6)) - 1];
        this.endTime =
          this.defaultQuarterValue[1].slice(0, 4) +
          endArr[parseInt(this.defaultQuarterValue[1].slice(5, 6)) - 1];
      } else if (value === "month") {
        this.times = this.defaultMonthValue;
        this.startTime = this.defaultMonthValue[0];
        this.endTime = this.defaultMonthValue[1];
      } else {
        this.startTimeDef = new Date().getFullYear() - 4 + "";
        this.endTimeDef = new Date().getFullYear() + "";
        this.startTime = new Date().getFullYear() - 4 + "-01";
        this.endTime = new Date().getFullYear() + "-12";
      }
      this.initData();
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    handelFix1(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    initData() {
      console.log(this.regionCodeDef);
      const self = this;
      this.loading = true;
      this.queryData.startTime = this.startTime;
      this.queryData.endTime = this.endTime;
      this.$axios
        .post("/business/invest/queryList", this.queryData)
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            pre: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit: "亿元",
          };
          this.showArea = false;
          this.loading = false;
          this.srcDataList = res.data;
          this.getShowData();
        });
    },
    getQuarter(value) {
      this.QuarterValue = value;
      const startArr = ["-01", "-04", "-07", "-10"];
      const endArr = ["-03", "-06", "-09", "-12"];
      this.startTime =
        value[0].slice(0, 4) + startArr[parseInt(value[0].slice(5, 6)) - 1];
      this.endTime =
        value[1].slice(0, 4) + endArr[parseInt(value[1].slice(5, 6)) - 1];
      this.initData();
    },
    getYearRange(value) {
      this.startTime = value[0] + "-01";
      this.endTime = value[1] + "-12";
      this.initData();
    },
    getShowData() {
      if (this.dataRange === "month") {
        this.getShowMonthData();
      } else if (this.dataRange === "quarter") {
        this.getShowQuarterData();
      } else {
        this.getShowYearData();
      }
    },
    getShowMonthData() {
      // 计算月度数据
      const self = this;
      this.tableData = [];
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      };
      this.showArea = false;
      const resultData = {};
      // 分年
      this.srcDataList.forEach((item) => {
        if (resultData.hasOwnProperty(item.year_query)) {
          resultData[item.year_query].push(item);
        } else {
          resultData[item.year_query] = [];
          resultData[item.year_query].push(item);
        }
      });
      let resultList = [];
      // 计算累计数据
      for (const key in resultData) {
        let currCount = 0;
        let preCount = 0;
        resultData[key].forEach((item) => {
          if (this.dataIndex === "gytz") {
            currCount = currCount + item.bu_this;
            preCount = preCount + item.bu_last;
            item.curr = item.bu_this;
            item.pre = item.bu_last;
            item.growthRate = item.bu_sync;
            item.currCount = currCount;
            item.preCount = preCount;
            item.growthRateCount =
              item.preCount == 0
                ? "--"
                : ((item.currCount - item.preCount) / item.preCount) * 100;
          } else if (this.dataIndex === "jgtz") {
            currCount = currCount + item.tech_this;
            preCount = currCount + item.tech_last;
            item.curr = item.tech_this;
            item.pre = item.tech_last;
            item.growthRate = item.tech_sync;
            item.currCount = currCount;
            item.preCount = preCount;
            item.growthRateCount =
              item.preCount == 0
                ? "--"
                : ((item.currCount - item.preCount) / item.preCount) * 100;
          }
        });
        resultList = resultList.concat(resultData[key]);
      }
      this.tableData = [];
      // 展示数据过滤
      resultList.forEach((item) => {
        const dateRange = item.date_range.trim();
        if (
          this.times[0].trim() <= dateRange &&
          dateRange <= this.times[1].trim()
        ) {
          this.areaData.xAxis.push(dateRange);
          item.date_range_show =
            item.date_range.split("-")[0] +
            "年" +
            item.date_range.split("-")[1] +
            "月";
          if (this.dataTpye === "all") {
            this.areaData.curr.name = "累计";
            this.areaData.pre.name = "上年同期";
            this.areaData.profit.name = "同比增速";
            this.areaData.curr.data.push(item.currCount);
            this.areaData.pre.data.push(item.preCount);
            this.areaData.profit.data.push(item.growthRateCount);
          } else {
            this.areaData.curr.name = "当期";
            this.areaData.pre.name = "上年同期";
            this.areaData.profit.name = "同比增速";
            this.areaData.curr.data.push(item.curr);
            this.areaData.pre.data.push(item.pre);
            this.areaData.profit.data.push(item.growthRate);
          }
          this.tableData.push(item);
        }
      });
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getShowQuarterData() {
      // 计算季度数据
      const self = this;
      this.tableData = [];
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      };
      this.showArea = false;
      const resultData = {};
      // 分年分季度
      this.srcDataList.forEach((item) => {
        if (resultData.hasOwnProperty(item.year_query)) {
          if (resultData[item.year_query].hasOwnProperty(item.quarter_query)) {
            resultData[item.year_query][item.quarter_query].push(item);
          } else {
            resultData[item.year_query][item.quarter_query] = [];
            resultData[item.year_query][item.quarter_query].push(item);
          }
        } else {
          resultData[item.year_query] = {};
          resultData[item.year_query][item.quarter_query] = [];
          resultData[item.year_query][item.quarter_query].push(item);
        }
      });
      let resultList = [];
      // 计算累计数据
      for (const key in resultData) {
        const yearData = resultData[key];
        let currCount = 0;
        let preCount = 0;
        for (const year in yearData) {
          let curr = 0;
          let pre = 0;
          const temp = {};
          yearData[year].forEach((item) => {
            temp.date_range_show =
              item.year_query + "年第" + item.quarter_query + "季度";
            temp.date_range = item.date_range;
            if (this.dataIndex === "gytz") {
              currCount = currCount + item.bu_this;
              preCount = preCount + item.bu_last;
              curr = curr + item.bu_this;
              pre = pre + item.bu_last;
            } else if (this.dataIndex === "jgtz") {
              currCount = currCount + item.tech_this;
              preCount = preCount + item.tech_last;
              curr = curr + item.tech_this;
              pre = pre + item.tech_last;
            }
          });
          temp.currCount = currCount;
          temp.preCount = preCount;
          temp.curr = curr;
          temp.pre = pre;
          temp.growthRate =
            temp.pre > 0 ? ((temp.curr - temp.pre) / temp.pre) * 100 : "--";
          temp.growthRateCount =
            temp.preCount > 0
              ? ((temp.currCount - temp.preCount) / temp.preCount) * 100
              : "--";
          resultList = resultList.concat(temp);
        }
      }
      this.tableData = [];
      // 展示数据过滤
      resultList.forEach((item) => {
        this.areaData.xAxis.push(item.date_range_show);
        if (this.dataTpye === "all") {
          this.areaData.curr.name = "累计";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(item.currCount);
          this.areaData.pre.data.push(item.preCount);
          this.areaData.profit.data.push(item.growthRateCount);
        } else {
          this.areaData.curr.name = "当期";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(item.curr);
          this.areaData.pre.data.push(item.pre);
          this.areaData.profit.data.push(item.growthRate);
        }
        this.tableData.push(item);
      });
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getShowYearData() {
      // 计算年度数据
      const self = this;
      this.tableData = [];
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      };
      this.showArea = false;
      const resultData = {};
      // 分年
      this.srcDataList.forEach((item) => {
        if (resultData.hasOwnProperty(item.year_query)) {
          resultData[item.year_query].push(item);
        } else {
          resultData[item.year_query] = [];
          resultData[item.year_query].push(item);
        }
      });
      let resultList = [];
      // 计算累计数据
      for (const key in resultData) {
        let currCount = 0;
        let preCount = 0;
        resultData[key].forEach((item) => {
          item.date_range_show = item.year_query + "年";
          if (this.dataIndex === "gytz") {
            currCount = currCount + item.bu_this;
            preCount = preCount + item.bu_last;
            item.curr = item.bu_this;
            item.pre = item.bu_last;
            item.growthRate = item.bu_sync;
            item.currCount = currCount;
            item.preCount = preCount;
            item.growthRateCount =
              item.preCount > 0
                ? ((item.currCount - item.preCount) / item.preCount) * 100
                : "--";
          } else if (this.dataIndex === "jgtz") {
            currCount = currCount + item.tech_this;
            preCount = currCount + item.tech_last;
            item.curr = item.tech_this;
            item.pre = item.tech_last;
            item.growthRate = item.tech_sync;
            item.currCount = currCount;
            item.preCount = preCount;
            item.growthRateCount =
              item.preCount > 0
                ? ((item.currCount - item.preCount) / item.preCount) * 100
                : "--";
          }
        });
        resultList.push(resultData[key][resultData[key].length - 1]);
      }
      this.tableData = [];
      // 展示数据过滤
      resultList.forEach((item) => {
        const dateRange = item.date_range.trim();
        this.areaData.xAxis.push(dateRange);
        if (this.dataTpye === "all") {
          this.areaData.curr.name = "累计";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(item.currCount);
          this.areaData.pre.data.push(item.preCount);
          this.areaData.profit.data.push(item.growthRateCount);
        } else {
          this.areaData.curr.name = "当期";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(item.curr);
          this.areaData.pre.data.push(item.pre);
          this.areaData.profit.data.push(item.growthRate);
        }
        item.date_range_show = item.year_query + "年";
        this.tableData.push(item);
      });
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      let year = this.timesDef.slice(0, 4);
      this.defaultMonthValue = [year + "-01", this.timesDef || year + "-12"];
      //下面是几个if
      if (this.timesDef) {
        const selectMonth = parseInt(this.timesDef.split("-").pop());
        //下面是几个if
        if (selectMonth >= 1 && selectMonth <= 3)
          return [year + "-" + "1", year + "-" + "1"];
        else if (selectMonth >= 4 && selectMonth <= 6) {
          return [year + "-" + "1", year + "-" + "2"];
        } else if (selectMonth >= 7 && selectMonth <= 9) {
          return [year + "-" + "1", year + "-" + "3"];
        } else if (selectMonth >= 10 && selectMonth <= 12) {
          return [year + "-" + "1", year + "-" + "4"];
        }
      } else {
        return [year + "-" + "1", year + "-" + "4"];
      }
    },
    yearChange(value) {
      this.times = value + "-12";
      this.initData();
    },
    monthChange(value) {
      this.startTime = value[0].slice(0, 4) + "-01";
      this.endTime = value[1].slice(0, 4) + "-12";
      this.initData();
    },
    changeDataIndex(value) {
      this.$emit("changeDataIndex", value);
      this.getShowData();
    },
    exportData() {
      let column = [];
      if (this.dataRange === "year") {
        column = [
          {
            title: "时间",
            key: "date_range",
            rowspan: 2,
          },
          {
            title: "本年累计",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "currCount",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "preCount",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRateCount",
              },
            ],
            colspan: 3,
          },
        ];
      } else {
        column = [
          {
            title: "时间",
            key: "date_range_show",
            rowspan: 2,
          },
          {
            title:
              this.dataRange === "quarter"
                ? "当季数据"
                : this.dataRange === "year"
                ? "当年数据"
                : "当月数据",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "curr",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "pre",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRate",
              },
            ],
            colspan: 3,
          },
          {
            title: "本年累计",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "currCount",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "preCount",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRateCount",
              },
            ],
            colspan: 3,
          },
        ];
      }
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr =
          this.startTime.slice(0, 4) + "年到" + this.endTime.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        timeStr =
          this.QuarterValue[0].slice(0, 4) +
          "年第" +
          this.QuarterValue[0].slice(5, 6) +
          "季度到" +
          this.QuarterValue[1].slice(0, 4) +
          "年第" +
          this.QuarterValue[1].slice(5, 6) +
          "季度";
      } else {
        timeStr =
          this.times[0].slice(0, 4) +
          "年" +
          this.times[0].slice(5, 7) +
          "月到" +
          this.times[1].slice(0, 4) +
          "年" +
          this.times[1].slice(5, 7) +
          "月";
      }
      export2Excel(column, this.tableData, this.title + "_" + timeStr);
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.times = this.defaultMonthValue;
    this.QuarterValue = this.defaultQuarterValue;
    if (this.dataRangeDef === "year") {
      // 季度数据，默认取近五年的数据
      let year = this.timesDef.slice(0, 4);
      this.endTimeDef = year + "";
      year = parseInt(year) - 4;
      this.startTimeDef = year + "";
      this.startTime = year + "-01";
      this.endTime = this.timesDef;
    } else if (this.dataRangeDef === "quarter") {
      // 季度数据，默认取当年全年的数据
      this.startTime = this.timesDef.slice(0, 4) + "-01";
      this.endTime = this.timesDef.split(",")[1];
    } else {
      this.startTime = this.defaultMonthValue[0];
      this.endTime = this.defaultMonthValue[1];
      this.times = [this.startTime, this.endTime];
    }
    this.initData();
  },
};
</script>